import {useI18n} from 'vue-i18n'

import {useSettingsStore} from "@/stores/SettingsStore"

export function useHelpers() {
	const {t} = useI18n()
	const settingsStore = useSettingsStore()

	const formatMoney = (value, c = 'CZK', l = 'cs-CZ') => {

		let currency = c
		let locale = l
		let maximumFractionDigits = 0
		let minimumFractionDigits = 0

		if (window.settings.version === 'SK') {
			currency = 'EUR'
			locale = 'sk-SK'
			maximumFractionDigits = 2
			minimumFractionDigits = 2
		}

		if (window.settings.version === 'HU') {
			currency = 'HUF'
			locale = 'hu-HU'
			maximumFractionDigits = 2
			minimumFractionDigits = 2
		}

		const formatter = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency,
			minimumFractionDigits: minimumFractionDigits,
			maximumFractionDigits: maximumFractionDigits,
		})

		return formatter.format(value)
	}

	const visitUrl = (url) => {
		const fullUrl = url.startsWith('https://')
			? url
			: `${window.api.baseUrl}/${url}`

		if (inIframe()) {
			window.parent.postMessage({type: 'visitUrl', fullUrl}, '*')
			top.location.href = fullUrl
		} else {
			window.location.href = fullUrl
		}
	}

	const inIframe = () => {
		try {
			return window.self !== window.top
		} catch (e) {
			return true
		}
	}

	const sendMessage = (type, payload) => {
		console.log(`🚀 sending message: ${type} with payload: ${JSON.stringify(payload)}`)
		window.parent.postMessage(
			JSON.stringify({
				type: type,
				payload: payload
			}),
			'*'
		)
	}

	const ucFirst = (string) => {
		return string.charAt(0).toUpperCase() + string.slice(1)
	}

	const getI18nCarouselOptions = () => {
		return {
			ariaNextSlide: t('Next Slide'),
			ariaPreviousSlide: t('Previous Slide'),
			ariaNavigateToSlide: t('Jump to Slide {slideNumber}'),
			ariaGallery: t('Gallery'),
			itemXofY: t('Slide {currentSlide} from {slidesCount}'),
			iconArrowUp: t('Go Uo'),
			iconArrowDown: t('Go Down'),
			iconArrowRight: t('Go Right'),
			iconArrowLeft: t('Go Left')
		}
	}

	const getAddress = (address) => {
		return {
			id: address?.id || null,
			first_name: address?.first_name || "",
			last_name: address?.last_name || "",
			address: address?.address || "",
			number: address?.number || "",
			zip: address?.zip || "",
			city: address?.city || "",
			country: address?.country || window.settings.version,
			phone_number: address?.phone_number || "",
			company_name: address?.company_name || "",
		}
	}

	const getInvoiceAddress = (address) => {
		return {
			...getAddress(address),
			company_id: address?.company_id || "",
			tax_id: address?.tax_id || "",
			vat_id: address?.vat_id || "",
		}
	}

	const isObjectEmpty = (object) => {
		return Object.keys(object).length === 0
	}

	const addDefaultPhonePrefixIntoAddress = (address) => {
		return address
			? {
				...address,
				phone_number: address.phone_number || settingsStore.defaultPhonePrefix
			} : {
				phone_number: settingsStore.defaultPhonePrefix
			}
	}

	const getAddressWithoutPhonePrefix = (address) =>
		address ? {...address, phone_number: address.phone_number?.replace(/^\+(420|421|36)/, '') || ''} : {}

	return {
		formatMoney,
		inIframe,
		sendMessage,
		visitUrl,
		getI18nCarouselOptions,
		ucFirst,
		getAddress,
		getInvoiceAddress,
		isObjectEmpty,
		addDefaultPhonePrefixIntoAddress,
		getAddressWithoutPhonePrefix,
	}
}
